










import { NextQuery } from '@empathy/search-types';
import { EVENTS } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class GoccoHeaderNextQuery extends Vue {
  @Prop({ required: true })
  private nextQuery: NextQuery;

  get titleMsgOptions() {
    return { numFound: this.nextQuery.numFound, query: this.nextQuery.query };
  }

  get viewAllMsgOptions() {
    return { numFound: this.nextQuery.numFound };
  }

  selectNextQuery() {
    this.$x.emit(EVENTS.SelectNextQuery, this.nextQuery);
  }
}
